var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/utility-currency-image.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"c-utility__svg c-utility__svg--currency\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.965 19.424\">\n\n\t<path d=\"M11.523,1.977a6.75,6.75,0,1,0-9.546,9.545,6.75,6.75,0,1,0,9.546-9.545Zm-.707,8.838A5.75,5.75,0,1,1,2.684,2.684a5.75,5.75,0,1,1,8.132,8.131Z\"/>\n\n\t<path d=\"M13.266,13.266a9.215,9.215,0,0,0,0-13.032l-.707.707a8.216,8.216,0,0,1,0,11.618,8.216,8.216,0,0,1-11.618,0l-.707.707a9.152,9.152,0,0,0,6.516,2.7v2.459H2.58v1h9.34v-1H7.75V15.908A9.141,9.141,0,0,0,13.266,13.266Z\"/>\n\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/utility-currency-image.j2"] , dependencies)